// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31MXV","inner":"Form_inner__3mrFg","range":"Form_range__1m10u","name":"Form_name__3PybE","actions":"Form_actions__1-pYh"};